import ApiService from '@/core/services/ApiService';
import { Actions as ErrorActions } from '@/store/enums/ErrorHandleEnum';
import { useStore } from 'vuex';
import store from '@/store';
export default class Pbi {
    constructor(pbiConfig) {
        this.pbiConfig = pbiConfig;
    }
    // start: GETTER ======================
    getPbiConfig() {
        return this.pbiConfig;
    }
    // end: GETTER ========================
    // start: SETTER ======================
    setPbiConfig(pbiConfig) {
        this.pbiConfig = pbiConfig;
    }
    setPbiUrl(url) {
        Pbi.baseUrl = url;
    }
    setPbiIsCompleteUrl(status) {
        Pbi.isCompleteUrl = status;
    }
    // end: SETTER ========================
    getApiPbiConfig(payload) {
        let pbiCustomUrl = '';
        let pbiSingleRoles = '';
        if (payload.pbiUserRoles && payload.pbiUserRoles.includes('Medic')) {
            pbiSingleRoles = 'medic';
        }
        else if (payload.pbiUserRoles &&
            payload.pbiUserRoles.includes('Datakeeper')) {
            pbiSingleRoles = 'datakeeper';
        }
        if (payload.pbiUserRoles &&
            (payload.pbiUserRoles.includes('Medic') ||
                payload.pbiUserRoles.includes('Datakeeper'))) {
            pbiCustomUrl = `${Pbi.baseUrl}/api/embedinfo/${payload.reportName}?siteId=${payload.pbiSiteId}&roles=${pbiSingleRoles}&ver=v1`;
        }
        else if (window.location.href.includes('operatorabuse')) {
            pbiCustomUrl = `${Pbi.baseUrl}/api/embedinfo/Abuse?ver=v1`;
        }
        else {
            pbiCustomUrl = `${Pbi.baseUrl}/api/embedinfo/${payload.reportName}?ver=v1`;
        }
        return new Promise((resolve, reject) => {
            ApiService.get(Pbi.isCompleteUrl ? Pbi.baseUrl : pbiCustomUrl)
                .then(({ data }) => {
                if (data.statusCode === 200) {
                    const resData = data.result.content;
                    this.pbiConfig = resData;
                    resolve();
                }
                else {
                    Pbi.callErrorAction(payload, data);
                }
            })
                .catch(({ response }) => {
                reject();
                Pbi.callErrorAction(payload, response.data);
            });
        });
    }
    postApiPbiConfig(payload) {
        if (store.getters.currentUser.email) {
            return new Promise((resolve, reject) => {
                ApiService.post(Pbi.isCompleteUrl
                    ? Pbi.baseUrl
                    : `${Pbi.baseUrl}/api/embedinfo/?ver=v1`, {
                    reportName: payload.reportName,
                    email: store.getters.currentUser.email
                })
                    .then(({ data }) => {
                    if (data.statusCode === 200) {
                        const resData = data.result.content;
                        this.pbiConfig = resData;
                        resolve();
                    }
                    else {
                        Pbi.callErrorAction(payload, data);
                    }
                })
                    .catch(({ response }) => {
                    reject();
                    Pbi.callErrorAction(payload, response.data);
                });
            });
        }
    }
    static callErrorAction(payload, response) {
        let errMessage = '';
        if ('message' in response) {
            errMessage = response.message;
        }
        else {
            const resultMsg = response.result.message;
            const resultContent = response.result.content;
            errMessage = resultMsg ? resultMsg : resultContent;
        }
        store.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
            page: payload.pageName,
            type: 'unhandledError',
            name: `get-${payload.pageName}-PbiEmbed`,
            message: `${response.statusCode} - ${errMessage}`
        });
    }
}
Pbi.baseUrl = ``;
Pbi.store = useStore();
Pbi.isCompleteUrl = false;
